export default {
  init() {
    const $checkoutForm = jQuery('#zd-checkout-form')
    const $alertSection = jQuery('#js-zd-checkout__notification');
    const $alertTextEl = jQuery('#js-zd-checkout__notification__text', $alertSection)

    jQuery(document).on('checkout_error', () => {
      $alertTextEl.text('')

      const $alertText = $checkoutForm.find('.woocommerce-NoticeGroup-checkout').text().trim()

      $alertSection.addClass('is-visible').removeClass('zd-visibility-hidden')
      $alertTextEl.text($alertText || 'Something went wrong.')

      $checkoutForm.one('input keyup change paste', 'input, select', () => {
        $alertSection.removeClass('is-visible')

        setTimeout(() => {
          $alertSection.addClass('zd-visibility-hidden')
        }, 310)

      })
    })
  },
};
